module.exports = __webpack_public_path__ + "img/by.417d52d0.svg";